import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import DataTable from "../../common/dataTable";
import PageBreadcrumb from "../../common/PageBreadcrumb/PageBreadcrumb";
import { useCapaAccess } from "./capaAccess";
import { fetchCapaApprovals } from "./capaService";
import "./CapaPages.scss";

const CapaApprovals = () => {
  const navigate = useNavigate();
  const { userData, canCapaMyWork } = useCapaAccess();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const r = await fetchCapaApprovals(userData);
      if (!cancelled) setRows(r);
    })();
    return () => {
      cancelled = true;
    };
  }, [userData]);

  const columns = [
    { label: "CAPA no.", accessor: "CapaNo" },
    { label: "Stage", accessor: "Stage" },
    { label: "Owner", accessor: "SubmittedBy" },
    { label: "Updated", accessor: "SubmittedAt", type: "date" },
    { label: "Due", accessor: "DueDate", type: "date" },
  ];

  const actions = [
    {
      label: "Open",
      className: "btn-primary btn-sm",
      onClick: (row) => row.CapaId && navigate(`/capa/${row.CapaId}`),
    },
  ];

  if (!userData) {
    return (
      <div className="d-flex justify-content-center p-5">
        <div className="spinner-border" role="status" />
      </div>
    );
  }
  if (!canCapaMyWork) return <Navigate to="/notification-center" replace />;

  return (
    <div className="capa-page">
      <PageBreadcrumb
        items={[
          { label: "Home", path: "/notification-center" },
          { label: "CAPA approvals" },
        ]}
        actions={[
          { icon: "fas fa-list", label: "CAPA list", onClick: () => navigate("/capa") },
        ]}
      />
      <DataTable data={rows} columns={columns} actions={actions} showToggle={true} />
    </div>
  );
};

export default CapaApprovals;
